import styled, { css } from 'styled-components';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Picture from '@nmx/template/dist/componentLibrary/components/Picture';

export const ColStyled = styled(Col)`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

export const PictureStyled = styled(Picture)`
  ${({ theme }) => {
    const smallUp = theme.smallUp();
    const mediumUp = theme.mediumUp();
    let thisMaxWidth = '60%';
    if(mediumUp){
      thisMaxWidth = '70%';
    } else if(smallUp){
      thisMaxWidth = '50%';
    }

    return css`
      max-width: ${thisMaxWidth};
    `;
  }}
`;